module.exports = __webpack_public_path__ + "static/media/cat-appliances.c79bae49.svg";